import React from "react";

export default function Modal({ title, children, onClose, size = "md", testId }) {
    const widths = {
        sm: "max-w-md",
        md: "max-w-lg",
        lg: "max-w-2xl",
        xl: "max-w-4xl",
    };
    return (
        <div
            className="fixed inset-0 z-50 flex items-start justify-center bg-black/40 px-4 py-8 overflow-y-auto"
            onClick={onClose}
            data-testid={testId || "modal-overlay"}
        >
            <div
                className={`w-full ${widths[size]} bg-white border border-gray-200 rounded-sm`}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="border-b border-gray-200 px-5 py-3 flex items-center justify-between sticky top-0 bg-white">
                    <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-700 text-sm"
                        data-testid="modal-close"
                    >
                        ✕
                    </button>
                </div>
                <div className="p-5">{children}</div>
            </div>
        </div>
    );
}
